import { NgModule } from '@angular/core';
import { AiAnalyzeButtonComponent } from './components/analyze-button/ai-analyze-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { AiAnalysisResultComponent } from './components/analyze-button/components/ai-analysis-result/ai-analysis-result.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@masar/shared/shared.module';
import { ChatComponent } from './components/chat/chat.component';
import { FormsModule } from '@angular/forms';
import { ChatMessageComponent } from './components/chat/components/chat-message/chat-message.component';
import { ChatMessageListComponent } from './components/chat/components/chat-message-list/chat-message-list.component';
import { TranslateToolNamePipe } from './components/chat/pipes/translate-tool-name.pipe';

@NgModule({
    declarations: [
        AiAnalyzeButtonComponent,
        AiAnalysisResultComponent,
        ChatComponent,

        // Components
        ChatMessageComponent,
        ChatMessageListComponent,

        // Pipes
        TranslateToolNamePipe,
    ],
    imports: [CommonModule, TranslateModule, SharedModule, FormsModule],
    exports: [AiAnalyzeButtonComponent, ChatComponent],
})
export class AiModule {}
